module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/concierge_female-3b837d93a1691230478751932aa5dd88.webp";